import { Button, Card, Form } from 'react-bootstrap';
import styled from 'styled-components';

interface StyledButtonProps {
  variant: 'primary' | 'secondary'; 
  disabled?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
}

export const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to bottom, #03113E, #03357A);
  background-size: cover;  
  background-position: center; 
  background-repeat: no-repeat;
  display: flex;          
  justify-content: center;
  align-items: center;
`

export const StyledCard = styled(Card)`
  padding: 2.5rem !important;
  gap: 1.25rem;
  flex-direction: column;
  display: flex;
  border-width: 0 !important;
  border-style: solid !important;
  border-color: #f1f1f4 !important;
  border-radius: .75rem !important;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, .03) !important;
  border: 2px solid #f1f1f4 !important;
  width: 30% !important;
`;

export const StyledInput = styled(Form.Control)`
  display: block;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-shadow: none;
  outline: none;
  font-weight: 500;
  font-size: 0.8125rem;
  line-height: 1;
  background-color: #fcfcfc;
  border-radius: 0.375rem;
  height: 2.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border: 1px solid #dbdfe9;
  color: #4b5675 !important;
`;

export const StyledButton = styled(Button)<StyledButtonProps>`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  line-height: 1;
  border-radius: .375rem;
  height: 2.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  gap: .375rem;
  border: 1px solid transparent;
  font-weight: 500;
  font-size: .8125rem !important;
  outline: none;
  justify-content: center;
  background-color: #262c47;
  color: white !important;
`;

export const StyledLabel = styled(Form.Label)`
  font-size: .8125rem;
  color: #071437;
`